import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between items-center w-full" }
const _hoisted_2 = { class: "flex gap-2 items-center" }
const _hoisted_3 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createBlock(_component_Accordion, {
    id: "chapter",
    activeIndex: _ctx.activeChapterIndex,
    onTabOpen: _cache[0] || (_cache[0] = ($event: any) => (_ctx.storeChapter.selectChapter($event.index))),
    class: "custom-details",
    lazy: ""
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeChapter.chapters, (chapter, chapterIndex) => {
        return (_openBlock(), _createBlock(_component_AccordionTab, {
          key: chapter.id,
          disabled: 
        _ctx.storeChapter.chapters[0] !== chapter &&
        !_ctx.storeChapter.chapters[chapterIndex - 1]?.done
      
        }, {
          header: _withCtx(() => [
            _createElementVNode("header", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_v_icon, {
                  name: "hi-solid-check-circle",
                  class: _normalizeClass([chapter.done ? 'text-green-600' : ''])
                }, null, 8, ["class"]),
                _createElementVNode("p", {
                  class: "line-clamp-2",
                  title: chapter.name
                }, _toDisplayString(chapter.name), 9, _hoisted_3)
              ])
            ])
          ]),
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 2
        }, 1032, ["disabled"]))
      }), 128))
    ]),
    _: 3
  }, 8, ["activeIndex"]))
}